import { types } from 'mobx-state-tree';


const Provider = types.model('Provider', {
    id: types.maybe(types.union(types.string, types.number)), // id may be missing on older applications
    slug: types.maybe(types.string),
    name: types.maybe(types.string),
});

export default Provider;
